"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconChevronDown = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 18 12",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
      points: "14.5 -1.39090909 12.8221937 -3 3.5 6 12.8316195 15 14.5 13.3909091 6.83676093 6",
      transform: "translate(9.000000, 6.000000) rotate(-90.000000) translate(-9.000000, -6.000000)"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconChevronDown')(IconChevronDown);